import { __decorate } from "tslib";
import { EventEmitter, Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { map } from "rxjs/operators";
import { ApiRecipientConstants } from "../../../constants/api-constants/api-recipient.constants";
import { HttpClient } from "@angular/common/http";
import { AlertType } from "../../../models/alert";
import { AppControllerService } from "../../../../app-controller.service";
import RecipientUtils from "../../../utils/recipient-utils";
let RecipientListService = class RecipientListService {
    http;
    appControllerService;
    requiredFields = new Subject();
    emitRecipient = new EventEmitter();
    emitRecipientList = new EventEmitter();
    constructor(http, appControllerService) {
        this.http = http;
        this.appControllerService = appControllerService;
    }
    checkStepMetaRecipientGroups(stepMetaGroups) {
        return stepMetaGroups.length > 0 ? RecipientUtils.mapStepMetaRecipientGroups(stepMetaGroups) : [];
    }
    getRecipients(params) {
        return this.http.get(ApiRecipientConstants.URL, { params })
            .pipe(map(response => {
            return response.value;
        }));
    }
    getRecipientsByGroup(params) {
        return this.http.post(`${ApiRecipientConstants.URL}/${ApiRecipientConstants.FUNCTION_GET_RECIPIENTS_BY_GROUP}`, params);
    }
    setRecipients(recipients, overrideGroup, recipientControl, removeId = false) {
        const values = [];
        recipients.forEach(recipient => {
            const recipientDeepCopy = RecipientUtils.makeDeepCopies(recipient, overrideGroup, removeId);
            recipientDeepCopy.setRecipient = true;
            values.push(recipientDeepCopy);
        });
        recipientControl.setValue({ recipients: values });
    }
    addRecipient(recipient, overrideGroup, recipientControl, removeId = false) {
        if (recipient) {
            const values = [];
            const recipientDeepCopy = RecipientUtils.makeDeepCopies(recipient, overrideGroup, removeId);
            values.push(recipientDeepCopy);
            recipientControl.setValue({ recipients: values });
        }
        else {
            this.appControllerService.showMessage("No recipient detected", AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AppControllerService }
    ];
};
RecipientListService = __decorate([
    Injectable({
        providedIn: "root"
    })
], RecipientListService);
export { RecipientListService };
